// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"57e11181","99":"5522f27a","146":"0b28ea7f","175":"78d49beb","204":"c5fd9800","349":"f7f1489b","479":"a23fb6a9","655":"0e907284","674":"eb33f100","768":"76920919","813":"501a17bb","963":"b33c7f4b"}[chunkId] + ".chunk.js";
};